import { render, staticRenderFns } from "./LessonBannerComponent.vue?vue&type=template&id=826b2b5c&scoped=true&"
import script from "./LessonBannerComponent.vue?vue&type=script&lang=js&"
export * from "./LessonBannerComponent.vue?vue&type=script&lang=js&"
import style0 from "./LessonBannerComponent.vue?vue&type=style&index=0&id=826b2b5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826b2b5c",
  null
  
)

component.options.__file = "LessonBannerComponent.vue"
export default component.exports